import React from "react";
import { toast, ToastContainer, ToastOptions, Id } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastNotification: React.FC = () => {
  return <ToastContainer position="top-right" autoClose={3000} closeOnClick pauseOnHover draggable />;
};

type ToastType = "success" | "error" | "info" | "warning";

// Track active toast messages
const activeToasts = new Map<string, Id>();

export const showToast = (message: string, type: ToastType = "success", options?: ToastOptions) => {

  const toastTypes = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warning,
  };

  // Show the toast and store its ID
  const toastId = toastTypes[type](message, {
    autoClose: 3000,
    onClose: () => activeToasts.delete(message), // Remove from tracking after closing
    ...options,
  });

  activeToasts.set(message, toastId);
};

export default ToastNotification;
